import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { EntryPageComponent } from './pages/entry-page/entry-page.component';
import { AuthAsComponent } from './shared/components/auth-as/auth-as.component';

const routes: Routes = [
  {
    path: '',
    component: EntryPageComponent,
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home-page/home-page.module').then( m => m.HomePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'company',
    loadChildren: () => import('./pages/company-page/company-page.module').then(m => m.CompanyPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact-page/contact-page.module').then(m => m.ContactPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'meetings',
    loadChildren: () => import('./pages/meeting-page/meeting-page.module').then(m => m.MeetingPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'integration',
    loadChildren: () => import('./pages/integration-page/integration-page.module').then(m => m.IntegrationPageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'insights',
    loadChildren: () => import('./pages/insights/insights.module').then(m => m.InsightsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile-page/profile-page.module').then(m => m.ProfilePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'tech-editor',
    loadChildren: () => import('./pages/buyer/tech-editor/tech-editor.module').then(m => m.TechEditorModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'tech-stack-visualizer',
    loadChildren: () => import('./pages/buyer/tech-stack-visualizer/tech-stack-visualizer.module').then(m => m.TechStackVisualizerModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'buyer-home',
    loadChildren: () => import('./pages/buyer/home-page/home-page.module').then(m => m.HomePageModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'products',
    loadChildren: () => import('./pages/buyer/products/products.module').then(m => m.ProductsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'product',
    loadChildren: () => import('./pages/buyer/product/product.module').then(m => m.ProductModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'setup-cohorts',
    loadChildren: () => import('./pages/buyer/setup-cohorts/setup-cohorts.module').then(m => m.SetupCohortsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'buyer-insights',
    loadChildren: () => import('./pages/buyer/insights/insights.module').then(m => m.InsightsModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'companies',
    loadChildren: () => import('./pages/buyer/companies/companies.module').then(m => m.CompaniesModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'company-search',
    loadChildren: () => import('./pages/buyer/company-search/company-search.module').then(m => m.CompanySearchModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'contact-search',
    loadChildren: () => import('./pages/buyer/contact-search/contact-search.module').then(m => m.ContactSearchModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'ai-chat',
    loadChildren: () => import('./pages/ai/ai.module').then(m => m.AiModule),
    canActivate: [AuthGuardService],
  },
  {
    path:'transformation-journeys',
    loadChildren: () => import('./pages/buyer/plays/plays.module').then(m => m.PlaysModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'my-contacts',
    loadChildren: () => import('./pages/contacts-owned-page/contacts-owned-page.module').then(m => m.ContactsOwnedPageModule),
    canActivate: [AuthGuardService],
  },
  // {
  //   path: 'companies/advanced-search',
  //    loadChildren: () => import('./pages/buyer/companies/companies.module').then(m => m.CompaniesModule)
  // },
  {
    path: 'auth-as',
    component: AuthAsComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'validate',
    loadChildren: () => import('./pages/validate/validate.module').then(m => m.ValidateModule),
  },
  { path: '**', redirectTo: '/buyer-home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
